<h1 mat-dialog-title>
    <i class="nio icon-transfere clickable" (click)="onGoBack()" *ngIf="!showOptions"></i>
    <span>{{ data.title | translate }}</span>
    <span [mat-dialog-close]="true"><i class="zmdi zmdi-close"></i></span>
</h1>
<div mat-dialog-content>
    <div class="listview" *ngIf="showOptions && data.options">
        <div class="listview-body">
            <div class="listview-item" *ngFor="let option of data.options">
                <div class="lvi-content">
                    <div class="avatar">{{ option.avatar }}</div>
                    <div class="lvi-body">
                        <div class="title">
                            <a class="label" (click)="selectOption(option)">{{ option.libelle }}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <list-view *ngIf="!showOptions && listeFiltres" [liste]="listeFiltres"></list-view>
</div>